/** Compared normalized: each form writes its own shape; a saved payment type stays listed. */

import config from '@/data/config';

const normalize = (value) => String(value ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toUpperCase()
  .replace(/^CONTA /, '');

export const isAllowedAccountType = (value) => config
  .BANK_ACCOUNT_TYPES_ALLOWED
  .includes(normalize(value));

// bank_accounts.account_type is varchar(8), so the saved value comes back cut.
const PAYMENT_STEM = config.BANK_ACCOUNT_TYPE_PAYMENT.slice(0, 8);

export const isPaymentAccountType = (value) => normalize(value)
  .startsWith(PAYMENT_STEM);
